import React from 'react';
// import '../../App.css';
import style from './Services.module.css';
import { useNavigate } from 'react-router-dom';
import ImageTruck from '../../components/componets/Image.js';
import image0 from '../../assets/images/tir.jpg'
import image1 from '../../assets/images/free-truck.png'
import image2 from '../../assets/images/tir.jpg'
export default function Services() {
  const navigate = useNavigate();
  return (
    <div className={style.home}>
      <div className={style.section} style={{ display: 'flex', justifyContent: 'center' }}>
        <div className={style.navigation}><ImageTruck image={image1} text='Baza transportów' href='/carriageList'/> </div>
        <div className={style.navigation}><ImageTruck image={image1} text='Baza palet' href='/carriagePaletteList'/></div>
        <div className={style.navigation}><ImageTruck image={image1} text='Baza serwisowa' href='/'/></div>
      </div>
    </div>
  );
}
